/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Call activity for a single user of an unproxied MCP server
 */
export type UnproxiedMcpServerUserUsageRow = {
  /**
   * Number of observed calls from this user
   */
  callCount: number;
  /**
   * Time of the user's most recent observed call, ISO 8601
   */
  lastCalledAt: Date;
  /**
   * The calling user's email, when Shadow MCP could resolve one
   */
  userEmail: string;
};

/** @internal */
export const UnproxiedMcpServerUserUsageRow$inboundSchema: z.ZodMiniType<
  UnproxiedMcpServerUserUsageRow,
  unknown
> = z.pipe(
  z.object({
    call_count: z.int(),
    last_called_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    user_email: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "call_count": "callCount",
      "last_called_at": "lastCalledAt",
      "user_email": "userEmail",
    });
  }),
);

export function unproxiedMcpServerUserUsageRowFromJSON(
  jsonString: string,
): SafeParseResult<UnproxiedMcpServerUserUsageRow, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UnproxiedMcpServerUserUsageRow$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UnproxiedMcpServerUserUsageRow' from JSON`,
  );
}
